<div class="loading-state">
    <div class="row" style="width: min-content; background: white; padding: 1rem; border-radius: 25px;">
        <div class="col-12" style="text-align: -webkit-center;">
            <div class="loading"></div>
        </div>
        <div class="col-12" style="text-align: -webkit-center;">
            <span>Loading...</span>
        </div>
    </div>
</div>